/**
 * Created by Fatih on 23.06.2016.
 */
import $ from 'jquery';
import login from './login.js';
import notifications from './notifications.js';
import spinner from './spinner.js';
import { replace, pushBack, basePathname } from './store/history.js';

const $termsAndConditionsPage = $('.terms-menu');

function setTermsAndConditionsPageActive(bool) {
	let logoutUponClose = login.checkComplianceFlag();

	if (bool) {
		$termsAndConditionsPage.addClass('menu--is-open');
		setTimeout(function () {
			$termsAndConditionsPage.css('transform', 'initial');

			//this part is for smooth scrolling in iOS
			$('.tabs-container').addClass('u-dn');
			if (window.location.href.indexOf('shop') !== -1) {
				$('.pusher').children().each(function () {
					$(this).addClass('u-dn');
				});
			}

		}, 500);

		if (logoutUponClose) {
			const bottom = $termsAndConditionsPage.find('.u-btn-wrapper');
			const isIphone = (/Safari/i.test(navigator.userAgent) && /Mobile/i.test(navigator.userAgent) && /iphone/i.test(navigator.userAgent));
			const isIpad = (/Safari/i.test(navigator.userAgent)) && (/Ipad/i.test(navigator.userAgent));

			//var isSafari = navigator.vendor.indexOf("Apple")==0 && /\sSafari\//.test(navigator.userAgent);

			bottom.show();
			/*
			if (isIpad || isIphone) {
				const marginPx = (isIpad) ? '50px' : '65px';
				bottom.css('margin-bottom', marginPx);
				$(window).on('resize', () => {
					if (bottom.attr('style').length !== 0) {
						bottom.removeAttr('style');
					}
				});
			}
			*/

		} else {
			//if we enter here, it means we dont need to show buttons
			$termsAndConditionsPage.find('.u-btn-wrapper').hide();
		}

	} else {
		$termsAndConditionsPage.removeClass('menu--is-open');
		$termsAndConditionsPage.removeAttr('style');

		//this part is for smooth scrolling in iOS
		$('.tabs-container').removeClass('u-dn');
		if (window.location.href.indexOf('shop') !== -1) {
			$('.pusher').children().each(function () {
				$(this).removeClass('u-dn');
			});
		}

		if (logoutUponClose) {
			notifications.hideNotification();
			$('.global-notification').removeClass('is-simple-notification');
			login.doLogout();
		}
	}
}

const closeBttn = $termsAndConditionsPage.find('.page-head').find('.icon-close');
closeBttn.click((e) => {
	e.preventDefault();
	e.stopPropagation();
	pushBack();
});

$termsAndConditionsPage.find('.btn-accept').click(function () {
	$(this).addClass('btn--is-loading');
	spinner.show($termsAndConditionsPage.find('.u-btn-wrapper'));
	login.doLogin(null, true);
	/*
		* Example scenario:
		* 		go to: #/withdraw
		*		user not logged in so,
		*			router.js assigns: redirectUrl = #/withdraw
		*			router.js redirects to: #/login
		*
		*		user logs in
		*		should-show-compliance-form, so
		*			login.js redirects to: #/terms-and-conditions (in this particular scenario. login.js has multiple execution branches…)
		*
		*		user clicks ”agree”
		*		terms-and-conditions must now tell router to redirect back to the original page (#/withdraw), so
		*			router.redirect()
		*
		*		router redirects to: redirectUrl (hopefully still #/withdraw)
		*		router assigns: redirectUrl = null;
		*
		*
		*/
	//we dont need a redirect because login function handles redirect
	//router.redirect();
});

$termsAndConditionsPage.find('.btn-logout').click(() => {
	login.doLogout();
	replace(basePathname());
});

export default {
	setTermsAndConditionsPageActive
};



// WEBPACK FOOTER //
// ./mobile-core/src/terms-and-conditions.js